
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/[pageSlug]",
      function () {
        return require("private-next-pages/page/[pageSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/page/[pageSlug]"])
      });
    }
  